var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#002147",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M15.683 2.883H1.817A1.067 1.067 0 00.75 3.95v11.733a1.067 1.067 0 001.067 1.067h13.866a1.067 1.067 0 001.067-1.067V3.95a1.067 1.067 0 00-1.067-1.067z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M.75 7.15h16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "M5.017 4.483V.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M12.483 4.483V.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M7.024 10.643a.267.267 0 110-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M7.024 10.643a.267.267 0 000-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M10.476 10.643a.267.267 0 010-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "M10.476 10.643a.267.267 0 000-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "M13.928 10.643a.267.267 0 010-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M13.928 10.643a.267.267 0 000-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M3.573 13.843a.267.267 0 010-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M3.572 13.843a.267.267 0 000-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M7.024 13.843a.267.267 0 110-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M7.024 13.843a.267.267 0 000-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "M10.476 13.843a.267.267 0 010-.533"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "M10.476 13.843a.267.267 0 000-.533"
  }))));
}
export default SvgIconCalendar;